import Splide from '@splidejs/splide';
// import AutoScroll from '@splidejs/splide-extension-auto-scroll';

$(function () {
  if( $('.splide.topMv-slide').length > 0 ) {
    new Splide(".splide.topMv-slide", {
      type: "fade",
      gap: 0,
      arrows: false,
      interval: 5000,
      pagination: false,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: true,
    }).mount();
  }
});

$(function () {
  if ($('.splide.splide-footer').length > 0) {
    new Splide(".splide.splide-footer", {
      type: "loop",
      gap: 0,
      perPage: 3,
      arrows: false,
      pagination: false,
      drag: false,
      autoScroll: {
        speed: 1,
      },
      breakpoints: {
        428: {
          perPage: 1,
        },
      },
    }).mount(window.splide.Extensions);
  }
});
